import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Typography, Drawer} from 'views/components';

import {Translate} from 'views/module';

const ClientLeadSettingsDrawer = (props) => {
  const settingsDrawerOpen = props.settingsDrawerOpen;
  const setSettingsDrawerOpen = props.setSettingsDrawerOpen;
  const children = props.children;

  return (
    <Drawer
      open={settingsDrawerOpen}
      onOpen={() => setSettingsDrawerOpen(true)}
      onClose={() => setSettingsDrawerOpen(false)}
      swipeable={true}
      PaperProps={{
        sx: {
          paddingX: 2,
          width: {
            xs: '80vw',
            sm: '456px',
          },
        },
      }}
    >
      <Typography sx={{textTransform: 'uppercase', fontWeight: 500, color: 'black'}} paddingTop='24px' paddingBottom='16px'>
        <Translate expression='clientLead.ClientLeadDetail.Settings.ContactInfo'/>
      </Typography>
      {children}
    </Drawer>
  );
};

ClientLeadSettingsDrawer.propTypes = {
  settingsDrawerOpen: PropTypes.bool.isRequired,
  setSettingsDrawerOpen: PropTypes.func.isRequired,
  children: PropTypes.node,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(ClientLeadSettingsDrawer));
